/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalComponentTaskType } from './MedicalComponentTaskType';
import {
    instanceOfMedicalComponentTaskType,
    MedicalComponentTaskTypeFromJSON,
    MedicalComponentTaskTypeFromJSONTyped,
    MedicalComponentTaskTypeToJSON,
} from './MedicalComponentTaskType';
import type { TaskType } from './TaskType';
import {
    instanceOfTaskType,
    TaskTypeFromJSON,
    TaskTypeFromJSONTyped,
    TaskTypeToJSON,
} from './TaskType';

/**
 * @type TaskTypeBase
 * 
 * @export
 */
export type TaskTypeBase = { $type?: 'Ptw.Ptw100.AppZero.Core.Shared.LicenseComponent.Models.MedicalComponentTaskType, Ptw.Ptw100.AppZero.Core.Shared' } & MedicalComponentTaskType | { $type?: 'Ptw.Ptw100.AppZero.Core.Shared.LicenseComponent.Models.TaskType, Ptw.Ptw100.AppZero.Core.Shared' } & TaskType;


export function TaskTypeBaseFromJSON(json: any): TaskTypeBase {
    return TaskTypeBaseFromJSONTyped(json, false);
}

export function TaskTypeBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskTypeBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Core.Shared.LicenseComponent.Models.MedicalComponentTaskType, Ptw.Ptw100.AppZero.Core.Shared':
            return {...MedicalComponentTaskTypeFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Core.Shared.LicenseComponent.Models.MedicalComponentTaskType, Ptw.Ptw100.AppZero.Core.Shared'};
        case 'Ptw.Ptw100.AppZero.Core.Shared.LicenseComponent.Models.TaskType, Ptw.Ptw100.AppZero.Core.Shared':
            return {...TaskTypeFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Core.Shared.LicenseComponent.Models.TaskType, Ptw.Ptw100.AppZero.Core.Shared'};
        default:
            throw new Error(`No variant of TaskTypeBase exists with '$type=${json['$type']}'`);
    }
}

export function TaskTypeBaseToJSON(value?: TaskTypeBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Core.Shared.LicenseComponent.Models.MedicalComponentTaskType, Ptw.Ptw100.AppZero.Core.Shared':
            return MedicalComponentTaskTypeToJSON(value);
        case 'Ptw.Ptw100.AppZero.Core.Shared.LicenseComponent.Models.TaskType, Ptw.Ptw100.AppZero.Core.Shared':
            return TaskTypeToJSON(value);
        default:
            throw new Error(`No variant of TaskTypeBase exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the TaskTypeBase interface.
 */
export function instanceOfTaskTypeBase(value: any): value is TaskTypeBase {
    if (instanceOfMedicalComponentTaskType(value)) return true;
    if (instanceOfTaskType(value)) return true;
    return false;
}

